import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import { Interweave } from 'interweave';
import NoSsr from '@mui/material/NoSsr';
import CustomModal from '../../../components/Modals/Modal';
import { ModalCloseBtn } from '../../../components/statelessComponents/Buttons/ButtonsInModals';
import CircularProgressSmall from '../../../components/CircularProgressSmall';
import ContextProvider from '../../../context';
import messages from './messages';
import s from './LessonReviewModal.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var LessonReviewModal = function LessonReviewModal(_ref) {
  var formatMessage = _ref.intl.formatMessage,
    closeLessonReviewContent = _ref.closeLessonReviewContent;
  var _useContext = useContext(ContextProvider),
    fetch = _useContext.fetch;
  var lesson = useSelector(function (state) {
    return state.lessonDetails.lesson;
  });
  var course = useSelector(function (state) {
    return state.courseDetails.course;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasReview = _useState2[0],
    setHasReview = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isReviewLoading = _useState4[0],
    setIsReviewLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isReviewSubmitting = _useState6[0],
    setIsReviewSubmitting = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    showSnackbarMessage = _useState8[0],
    setShowSnackbarMessage = _useState8[1];
  var _useState9 = useState({
      interestingQuestion: 3,
      challengingQuestion: 3,
      competentQuestion: 3
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    review = _useState10[0],
    setReview = _useState10[1];
  var marks = {
    interestingQuestion: [{
      value: 1,
      label: formatMessage(messages.noLabel)
    }, {
      value: 5,
      label: formatMessage(messages.yesLabel)
    }],
    challengingQuestion: [{
      value: 1,
      label: formatMessage(messages.easyLabel)
    }, {
      value: 5,
      label: formatMessage(messages.difficultLabel)
    }],
    competentQuestion: [{
      value: 1,
      label: formatMessage(messages.noviceLabel)
    }, {
      value: 5,
      label: formatMessage(messages.expertLabel)
    }]
  };
  var questions = {
    interestingQuestion: formatMessage(messages.interestingQuestion),
    challengingQuestion: formatMessage(messages.challengingQuestion),
    competentQuestion: formatMessage(messages.competentQuestion)
  };
  useEffect(function () {
    setIsReviewLoading(true);
    fetch("/api/lesson_reviews/".concat(course._id, "/").concat(lesson._id), {
      method: 'GET'
    }).then(function (res) {
      return res.json().then(function (resJson) {
        if (!res.ok) {
          throw new Error(resJson && resJson.message);
        }
        if (resJson && resJson.review) {
          setReview(_.omit(resJson.review, ['_id']));
          setHasReview(true);
        }
        setIsReviewLoading(false);
      });
    })["catch"](function (err) {
      setIsReviewLoading(false);
      setShowSnackbarMessage(err);
    });
  }, []);
  var handleReviewChange = function handleReviewChange(name) {
    return function (e, value) {
      setReview(function (prevReview) {
        return _objectSpread(_objectSpread({}, prevReview), {}, _defineProperty({}, name, value));
      });
    };
  };
  var submitReview = function submitReview() {
    setIsReviewSubmitting(true);
    setShowSnackbarMessage('');
    fetch("/api/lesson_reviews/".concat(course._id, "/").concat(lesson._id), {
      method: 'PUT',
      body: JSON.stringify({
        review: review
      })
    }).then( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
        var resJson;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (res.ok) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return res.json();
            case 3:
              resJson = _context.sent;
              throw new Error(resJson && resJson.message);
            case 5:
              setShowSnackbarMessage(formatMessage(messages.leaveRatingSuccess));
              setIsReviewSubmitting(false);
              setTimeout(function () {
                closeLessonReviewContent();
              }, 1000);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())["catch"](function (err) {
      setIsReviewSubmitting(false);
      setShowSnackbarMessage(err);
    });
  };
  return /*#__PURE__*/_jsx(CustomModal, {
    isOpen: true,
    overflowX: true,
    isLoaderOn: isReviewLoading,
    width: "fit-content",
    "data-test": "lesson-review-modal"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: classNames(s.rateContentWrapper)
  }, void 0, /*#__PURE__*/_jsx(Typography, {
    variant: "h5",
    component: "h1",
    gutterBottom: true
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.rateContentTitle)), /*#__PURE__*/_jsx(Typography, {
    variant: "subtitle1",
    classes: {
      root: s.rateContentHeadings
    }
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.rateContentHeading)), /*#__PURE__*/_jsx("div", {
    className: s.questionsWrapper
  }, void 0, Object.keys(questions).map(function (key) {
    return /*#__PURE__*/_jsx(React.Fragment, {}, key, /*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      classes: {
        root: classNames(s.rateContentHeadings, s.questionTitle)
      }
    }, void 0, questions[key]), /*#__PURE__*/_jsx(Slider, {
      min: 1,
      max: 5,
      value: review[key],
      onChange: handleReviewChange(key),
      disabled: isReviewLoading || isReviewSubmitting,
      marks: marks[key],
      classes: {
        markLabel: s.sliderMarkLabel
      }
    }));
  }), /*#__PURE__*/_jsx(Button, {
    "data-test-id": "elwHcSHbOOtbID16rFhO0",
    fullWidth: true,
    color: "primary",
    variant: "contained",
    "data-test": "submit-lesson-review-btn",
    className: s.submitBtn,
    onClick: submitReview,
    disabled: isReviewLoading || isReviewSubmitting
  }, void 0, hasReview ? /*#__PURE__*/React.createElement(FormattedMessage, messages.updateRatingLabel) : /*#__PURE__*/React.createElement(FormattedMessage, messages.submitRatingLabel), isReviewSubmitting && /*#__PURE__*/_jsx(CircularProgressSmall, {
    wrapperClassName: s.btnLoader
  })))), /*#__PURE__*/_jsx(ModalCloseBtn, {
    "data-test-id": "YyuOpfwEOVxFrLXvhUflh",
    fitMobileLandscapeFullWidth: true,
    "data-test": "skip-lesson-review-btn",
    onClick: closeLessonReviewContent,
    disabled: isReviewLoading || isReviewSubmitting
  }), /*#__PURE__*/_jsx(Snackbar, {
    open: !!showSnackbarMessage,
    onClose: function onClose() {
      return setShowSnackbarMessage('');
    },
    autoHideDuration: 2000,
    message: /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(Interweave, {
      tagName: "div",
      content: showSnackbarMessage
    }))
  }));
};
export default compose(injectIntl, withStyles(s))(LessonReviewModal);